/* eslint-disable */

import { uniq } from 'lodash';
import { EVENTS } from '../../../../app/constants/events';
import { COMPONENT_TYPE } from '../../../../app/constants/component_type';
import { REGEXES } from '../../../../app/constants/regexes';
import { getDataForSchemaImporter } from '../../../../app/package-designer/helpers/schema.helpers';

xplenty.controller('SchemaImporterController', [
  '$scope',
  '$rootScope',
  '$stateParams',
  '$timeout',
  '$controller',
  'connectionsService',
  'ConnectionItemsResource',

  function ($scope, $rootScope, $stateParams, $timeout, $controller, connectionsService, ConnectionItemsResource) {
    angular.extend(this, $controller('SchemaImporterSettingsController', { $scope }));

    $scope.loadingSchema = false;
    $scope.disableSelectAllFields = false;
    $scope.errorMessage = null;
    $scope.totalSelected = 0;
    $scope.availableFieldNames = [];

    const format = REGEXES.FIELD_NAME_FORMAT;
    const keywords = REGEXES.RESERVED_KEYWORDS;

    const checkPresenceOfFields = function () {
      const missedFields = [];
      if ($scope.availableFields.length) {
        _.each($scope.selectedFields, function (field) {
          if ($scope.availableFieldNames.indexOf(field.name) === -1) {
            missedFields.push(field.name);
          }
        });
        if (missedFields.length) {
          $scope.errorMessage =
            'Detected source schema doesn’t match selected schema. <a ng-click="replaceFields()">Click here</a> to replace the selected fields with new schema.';
        } else if ($scope.availableFields.length) {
          $scope.errorMessage = null;
        }
      }
    };

    const fillCategories = function () {
      $scope.selectedFields = $scope.selectedFields.map((selectedField) => {
        if (selectedField._category == undefined) {
          const availableField = _.find($scope.availableFields, { name: selectedField.name });
          if (availableField) {
            return { ...selectedField, _category: availableField.category };
          }
        }

        return { ...selectedField };
      });
    };

    $scope.replaceFields = function () {
      $scope.removeError();
      $scope.removeAll();
      $scope.selectAll();
    };

    const validateFields = function (selectedFields) {
      if (!selectedFields) return;

      const uniqueAliases = {};
      const uniqueNames = {};
      let allUnique = true;
      let hasError = false;

      _.each(selectedFields, function (field) {
        field.invalid = false;
        field.error = '';
        if (uniqueAliases[field.alias]) {
          allUnique = false;
          field.invalid = true;
          field.error = `Field alias '${field.alias}' - must be unique`;
          hasError = true;
        } else {
          uniqueAliases[field.alias] = field.alias;
        }
        if (field.alias === '') {
          field.invalid = true;
          field.error = "Field alias can't be empty";
          hasError = true;
        }
        if (field.alias !== '' && !format.test(field.alias)) {
          field.invalid = true;
          field.error = `Field alias '${field.alias}' - contains illegal characters`;
          hasError = true;
        }
        if (field.alias !== '' && keywords.test(field.alias)) {
          field.invalid = true;
          field.error = `Field alias '${field.alias}' - is an Xplenty reserved keyword`;
          hasError = true;
        }
        if (!field.name) {
          field.invalid = true;
          field.error = 'Field name is required';
          hasError = true;
        }
        if (uniqueNames[field.name]) {
          field.invalid = true;
          field.error = 'Field name must be unique';
          hasError = true;
        } else {
          uniqueNames[field.name] = field.name;
        }
      });

      $scope.hasSelectedFields =
        selectedFields.length > 0 &&
        _.some(selectedFields, function (field) {
          return !field.predefined;
        });
      $scope.hasError = hasError;
      $scope.fieldErrors = !hasError ? [] : selectedFields.filter((field) => field.invalid);
      $scope.valid = !$scope.hasError && $scope.hasSelectedFields;

      $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_CHANGED, $scope.selectedFields);
    };

    $scope.$watch('selectedFields', validateFields, true);

    const canSelectAll = function () {
      let canSelectAll = false;
      const availableNames = _.map($scope.availableFields, 'name');
      const selectedNames = _.map($scope.selectedFields, 'name');
      _.each(availableNames, function (availableName) {
        if (selectedNames.indexOf(availableName) == -1) {
          canSelectAll = true;
        }
      });
      return canSelectAll;
    };

    const checkSelection = function () {
      if (!$scope.component.schema || !$scope.selectedFields) return;
      const selectedFieldNames = [];
      _.each($scope.selectedFields, function (field) {
        selectedFieldNames.push(field.name);
      });
      let totalSelected = 0;
      _.each($scope.availableFields, function (field) {
        if (selectedFieldNames.indexOf(field.name) > -1) {
          totalSelected++;
          field.added = true;
        } else {
          field.added = false;
        }
      });
      $scope.totalSelected = totalSelected;
      $scope.setHeight();
      $scope.disableSelectAllFields = !canSelectAll();
    };

    const fieldCategory = 'Schema';

    const setFieldCategory = function (componentNew, componentOld) {
      if (
        componentNew &&
        componentOld &&
        (componentNew.response_type !== componentOld.response_type ||
          componentNew.record_type !== componentOld.record_type)
      ) {
        $scope.selectedFields = [];
      }
    };

    $scope.$watch('component', setFieldCategory, true);

    setFieldCategory();

    const setSchemaFields = function (fields) {
      let availableFields = [];
      let availableFieldNames = [];
      const names = {};
      let duplicateFieldsError;
      _.each(fields, function (field) {
        const fieldName = Object.keys(field)[0];
        if (!names.hasOwnProperty(fieldName)) {
          names[fieldName] = true;
          availableFields.push({
            name: fieldName,
            alias: fieldName,
            data_type: field[fieldName],
            category: fieldCategory,
          });
          availableFieldNames.push(fieldName);
        } else {
          duplicateFieldsError = true;
          $scope.errorMessage =
            'Duplicate fields were detected in source schema. Fields should have a unique identifier, please modify your query.';
          availableFieldNames = [];
          availableFields = [];
          return false;
        }
      });

      if ($scope.selectedFieldsOptions.hasEditableFields) {
        _.each($scope.selectedFields, function (field) {
          field.editable = !names.hasOwnProperty(field.name);
        });
      }
      $scope.availableFields = availableFields;
      $scope.availableFieldNames = availableFieldNames;

      if (!duplicateFieldsError) {
        setPredefinedFields();
        checkSelection();
        $timeout(checkPresenceOfFields);
      }

      // add all available fields if it is header based input
      // not doing this will break output schema if some fields are skipped in the source component
      if ($scope.component.record_type === 'delimited') {
        if ($scope.component.schema.fields && $scope.component.schema.fields.length > 0) {
          $timeout(() => {
            // selectPresetFields();
          }, 0);
        } else {
          $scope.removeAll();
          $scope.selectAll();
        }
      }

      return duplicateFieldsError;
    };

    $scope.getSchema = function () {
      $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_STARTED);

      $scope.setHeight();
      $scope.removeError();
      $scope.availableFields = [];
      $scope.showSelectedFields = true;
      $scope.loadingSchema = true;

      if ($scope.component.disableSchemaLoad) return;

      const schemaRequestData = getDataForSchemaImporter(
        $scope.component,
        $scope.component.componentType,
        $stateParams.account_id,
      );

      let connectionType;
      if (
        $scope.component.connection &&
        $scope.component.connection.type &&
        $scope.component.componentType !== COMPONENT_TYPE.REST_API_SOURCE_COMPONENT
      ) {
        connectionType = $scope.component.connection.type;
      } else {
        connectionType = 'curl';
        schemaRequestData.id = $scope.component.connection.id;
      }

      ConnectionItemsResource.schema(connectionType, $scope.component.connection.id, schemaRequestData).subscribe(
        function (res) {
          const hasError = setSchemaFields(res.fields);

          if (!hasError) {
            $scope.dataPreview = res;
            $scope.data = res;
            $scope.errorMessage = null;
          }
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADED, !hasError ? res : null);
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED);
          if ($scope.selectedFieldsOptions.autoSelectAllAvailableFields && $scope.selectedFields.length === 0) {
            $scope.selectAll();
          }
          fillCategories();
          $timeout(function () {
            $scope.loadingSchema = false;
          });
        },
        function (res) {
          $scope.errorMessage = _.escape((res.error && res.error.error_message) || '');
          $scope.data = null;
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_ERROR, res.error.error_message);
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED);
          setPredefinedFields();
          $timeout(function () {
            $scope.loadingSchema = false;
          });
        },
      );
    };

    if (!$scope.availableFields) {
      $scope.availableFields = [];
    }

    $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED, function () {
      $timeout(checkPresenceOfFields);
      validateFields($scope.selectedFields);
    });

    $scope.$on(EVENTS.SALESFORCE_OBJECT_PICKER_FIELDS_LOAD_START, function () {
      $scope.loadingSchema = true;
    });

    $scope.$on(EVENTS.SALESFORCE_OBJECT_PICKER_FIELDS_LOADED, function () {
      $scope.loadingSchema = false;
    });

    $scope.$on(EVENTS.NETSUITE_OBJECT_PICKER_FIELDS_LOAD_START, function () {
      $scope.loadingSchema = true;
    });

    $scope.$on(EVENTS.NETSUITE_OBJECT_PICKER_FIELDS_LOADED, function () {
      $scope.loadingSchema = false;
    });

    const createField = function (field) {
      return {
        alias: field.alias,
        data_type: field.data_type,
        name: field.name,
        disableSortable: field.disableSortable,
        disableTypeEdit: field.disableTypeEdit,
        required: field.required,
        predefined: field.predefined,
        _category: field.category,
        editable: field.editable,
      };
    };

    $scope.$on(EVENTS.SCHEMA_IMPORTER_ADD_FIELD, function (event, field) {
      field.alias = field.alias.replace(/\:/g, '_');
      let hasItem = false;

      if ($scope.selectedFields.length > 0) {
        _.each($scope.selectedFields, function (_field) {
          if (_field.name === field.name) {
            hasItem = true;
          }
        });
      }
      if (!hasItem) {
        if (!field.shouldBeUnshifted) $scope.selectedFields.push(createField(field));
        else $scope.selectedFields.unshift(createField(field));
      }
      checkSelection();
    });

    const removeField = function (field) {
      const selectedIndexToRemove = _.findIndex($scope.selectedFields, { name: field.name });
      const availableIndexToRemove = _.findIndex($scope.availableFields, { name: field.name });
      const availableNameIndexToRemove = $scope.availableFieldNames.indexOf(field.name);

      if (selectedIndexToRemove > -1) $scope.selectedFields.splice(selectedIndexToRemove, 1);
      if (availableIndexToRemove > -1) $scope.availableFields.splice(availableIndexToRemove, 1);
      if (availableNameIndexToRemove > -1) $scope.availableFieldNames.splice(availableNameIndexToRemove, 1);
    };

    var setPredefinedFields = function () {
      $timeout(function () {
        const fieldsToRemove = [];

        // remove any existing predefined field that don't exist in predefined list
        _.each($scope.selectedFields, function (field) {
          if (field.predefined) {
            const predefinedField = _.find($scope.selectedFieldsOptions.preDefinedFields, { name: field.name });
            if (!predefinedField || field.markedToBeRemoved) {
              fieldsToRemove.push(field);
            }
          }
        });

        _.each(fieldsToRemove, function (field) {
          removeField(field);
        });

        // possibly wrong place to store the predefined fields
        _.forEachRight($scope.selectedFieldsOptions.preDefinedFields, function (field) {
          const existingFieldIndex = _.findIndex($scope.selectedFields, { name: field.name });
          if (existingFieldIndex > -1) {
            _.extend(field, $scope.selectedFields[existingFieldIndex]);
            $scope.selectedFields.splice(existingFieldIndex, 1, createField(field));
            if (_.findIndex($scope.availableFields, { name: field.name }) === -1) $scope.availableFields.push(field);
            if ($scope.availableFieldNames.indexOf(field.name) === -1) $scope.availableFieldNames.push(field.name);
          } else {
            if (field.required) $scope.selectedFields.unshift(createField(field));
            if (_.findIndex($scope.availableFields, { name: field.name }) === -1) $scope.availableFields.push(field);
            if ($scope.availableFieldNames.indexOf(field.name) === -1) $scope.availableFieldNames.push(field.name);
          }
        });

        checkSelection();
      });
    };

    $scope.$on(EVENTS.SCHEMA_IMPORTER_SET_META_DATA_FIELDS, function (event) {
      setPredefinedFields();
      checkSelection();
    });
    $scope.$on(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, function (event, availableFields) {
      $scope.loadingSchema = false;
      $scope.availableFields = availableFields;
      $scope.availableFieldNames = [];
      _.each(availableFields, function (field) {
        $scope.availableFieldNames.push(field.name);
      });
      fillCategories();
      setPredefinedFields();
      checkSelection();
      $timeout(checkPresenceOfFields);
    });

    $scope.$on(EVENTS.SCHEMA_IMPORTER_GET_SCHEMA, function (event, disableSchemaLoad) {
      if (!disableSchemaLoad) $scope.getSchema();
    });

    $scope.$on(EVENTS.SCHEMA_IMPORTER_REMOVE_FIELD, function (event, field) {
      _.remove($scope.selectedFields, { name: field.name });
      checkSelection();
    });

    let add_couter = 0;

    $scope.$on(EVENTS.SCHEMA_IMPORTER_ADD_NEW_FIELD, function (event, field) {
      let fieldName = `FIELD_NAME_${add_couter}`;

      (function getNextField() {
        const field = _.find($scope.selectedFields, { name: fieldName });
        if (angular.isDefined(field)) {
          fieldName = `FIELD_NAME_${++add_couter}`;
          getNextField();
        }
      })();

      const newField = {
        name: field.name || fieldName,
        alias: field.alias || `FIELD_ALIAS_${add_couter}`,
        data_type: field.data_type || 'string',
        editable: field.editable || false,
      };

      ++add_couter;

      try {
        if (field.index == 0) {
          $scope.selectedFields.unshift(newField);
        } else if (field.index > 0) {
          $scope.selectedFields.splice(field.index, 0, newField);
        } else {
          $scope.selectedFields.push(newField);
        }

        checkSelection();
      } catch (e) {}
    });

    $scope.$on(EVENTS.SCHEMA_IMPORTER_TAB_SELECTED, function (event, field) {
      $scope.setHeight();
    });

    const selectPresetFields = function () {
      const fields = $scope.availableFields.map((field, idx) => {
        const presetFieldAlias =
          $scope.component.schema.fields[idx] && ($scope.component.schema.fields[idx].alias || null);
        const presetFieldDataType =
          $scope.component.schema.fields[idx] && ($scope.component.schema.fields[idx].data_type || null);
        const newPresetField = { ...field };
        newPresetField.alias = presetFieldAlias || field.alias;
        newPresetField.data_type = presetFieldDataType || field.data_type;
        return createField(newPresetField);
      });
      $scope.selectedFields = uniq(fields, (field) => field.name);
    };

    $scope.selectAll = function () {
      const fields = [];

      _.each($scope.availableFields, function (field) {
        const index = _.findIndex($scope.selectedFields, { name: field.name });
        if (field.category === fieldCategory && index === -1) {
          fields.push(createField(field));
        }
      });

      $scope.selectedFields = uniq($scope.selectedFields.concat(fields), (field) => field.name);

      checkSelection();
    };

    $scope.removeAll = function () {
      _.remove($scope.selectedFields, function (field) {
        return !field.required;
      });
      checkSelection();
    };

    $scope.removeError = function () {
      $scope.errorMessage = null;
      $scope.hasError = false;
    };

    $scope.refreshData = function () {
      if ($scope.component.componentType === COMPONENT_TYPE.REST_API_SOURCE_COMPONENT) {
        $scope.getSchema();
      } else {
        $rootScope.$broadcast(EVENTS.DATA_PREVIEW_REFRESH, _.map($scope.selectedFields, 'name'));
      }
    };
  },
]);
